import React from "react";
import InstantLeadCapture from "../../assets/images/Linkedin-ext/instant_lead_capture.png";
import ProfileInsights from "../../assets/images/Linkedin-ext/profile-insights.png";
import CustomOutreach from "../../assets/images/Linkedin-ext/custom-outreach.png";
import RealTimeSync from "../../assets/images/Linkedin-ext/real-time-sync.png";
import AdvanceSearchFilter from "../../assets/images/Linkedin-ext/advance-search-filter.png";

const featuresList = [
  {
    img: InstantLeadCapture,
    alt: "Instant Lead Capture",
    title: "Instant Lead Capture",
    desc: "Quickly capture and import lead information from LinkedIn profiles directly into your BeyondLeadz's dashboard with a single click.",
  },
  {
    img: ProfileInsights,
    alt: "Profile Insights",
    title: "Profile Insights",
    desc: "Access detailed information about your LinkedIn prospects, including job titles, company details, and mutual connections, all in one place.",
  },
  {
    img: CustomOutreach,
    alt: "Custom Outreach",
    title: "Custom Outreach",
    desc: "Use enriched data to personalize your connection requests and messages, increasing your chances of building meaningful professional relationships.",
  },
  {
    img: RealTimeSync,
    alt: "Real-Time Syncing",
    title: "Real-Time Syncing",
    desc: "Automatically sync LinkedIn lead data with your CRM and marketing automation tools, ensuring that your lead database is always up to date.",
  },
];

const FeatureGrid = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">

        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Product features
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            All-in-One <span className="tw-text-[#0077B5]">LinkedIn</span> Tool to Grow Your Business
          </h2>
        </div>

        {/* 2x2 Grid for standard features */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
          {featuresList.map((item, idx) => (
            <div
              key={idx}
              className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Text */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6 tw-flex-grow">
                {item.desc}
              </p>

              {/* Showcase Image container */}
              <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-mt-auto">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Full width bottom card for Advanced Search Filters */}
        <div className="tw-mt-8 tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.01] tw-transition-all tw-duration-300">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-8 tw-items-center tw-text-left">
            <div className="lg:tw-col-span-5">
              <h3 className="tw-text-xl tw-font-bold tw-text-slate-800 tw-mb-4">
                Advanced Search Filters
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                Leverage LinkedIn’s advanced search features to pinpoint the exact professionals you need, whether by industry, location, or company size.
              </p>
            </div>
            <div className="lg:tw-col-span-7 tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center">
              <img
                src={AdvanceSearchFilter}
                alt="Advanced Search Filters"
                className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                loading="lazy"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeatureGrid;
